import { Component, Input, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
  ENGINEERING_DEPARTMENT_OBSERVATION,
  HANDOVER_OBSERVATION_DATA_DIALOG_TITLE,
  HANDOVER_OBSERVATION_WELL_CONDITION,
  HANDOVER_OBSERVATION_WELL_CONDITION_DIALOG_TITLE,
  HANDOVER_TYPE_HO2_ID,
  HANDOVER_TYPE_HO3_ID,
  HANDOVER_TYPE_HO4_ID,
  HANDOVER_TYPE_HO5_ID,
  HANDOVER_TYPE_HOEC_ID,
  OPERATIONS_DEPARTMENT_OBSERVATION,
} from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import {
  HandoverEmitterObservation,
  HandoverHistoryObservation,
  HandoverObservation,
  ObservationAttachment,
} from 'src/app/interfaces/handover-observation';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { UserService } from 'src/app/services/user.service';
import { PendingChanges } from '../shared/pending-changes.class';
import { emit } from 'process';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-detail-footer-emitters',
  templateUrl: './handover-detail-footer-emitters.component.html',
  styleUrls: ['./handover-detail-footer-emitters.component.scss'],
  standalone: false,
})
export class HandoverDetailFooterEmittersComponent
  extends PendingChanges
  implements OnInit
{
  @Input() wellName: string | undefined;
  @Input() handover: Handover | undefined;
  @Input() readOnlyContent!: boolean;

  fullscreen = true;
  observations: HandoverEmitterObservation[] = [];
  engineeringOservations: HandoverEmitterObservation[] = [];
  receiverName = '';
  receiverEngineerName = '';
  historyObservations: HandoverHistoryObservation[] = [];
  viewHistory: {
    handoverObservationTypeId: number;
    viewHistory: boolean;
  }[] = [];
  isDr = false;
  operationsVisible = true;
  observationOperationsAttachment: any;
  observationEngineeringAttachment: any;
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;

  constructor(
    private dialogService: DialogService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private handoverService: HandoverService,
    private userService: UserService
  ) {
    super();
    this.matIconRegistry.addSvgIcon(
      'check-fill-green',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/check-fill-green.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'close-fill-red',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/close-fill-red.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'check',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/check.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'close',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/close.svg'
      )
    );
  }

  ngOnInit(): void {
    this.isDr = [
      HANDOVER_TYPE_HO2_ID,
      HANDOVER_TYPE_HO4_ID,
      HANDOVER_TYPE_HO5_ID,
      HANDOVER_TYPE_HOEC_ID,
    ].includes(this.handover!.handoverTypeId!);

    this.getLastObservations();
    this.getLastEngineeringObservations();
    this.getObservations();
    this.getObservationAttachments();
  }

  getLastObservations(): void {
    this.handoverService
      .getLastObservations(
        this.handover!.handoverId!,
        OPERATIONS_DEPARTMENT_OBSERVATION,
        this.isDr
      )
      .subscribe((emitterObservations: HandoverObservation[]) => {
        for (let index = 0; index < emitterObservations.length; index++) {
          const emitterObservation = emitterObservations[index];
          if (
            emitterObservation.handoverObservationId &&
            emitterObservation.emitterUserId == null
          ) {
            this.receiverName = emitterObservation.receiverName;
            this.observations.push({
              handoverObservationId: emitterObservation.handoverObservationId,
              handoverObservationTypeId:
                emitterObservation.handoverObservationTypeId,
              handoverObservationTypeDescription:
                emitterObservation.handoverObservationTypeDescription
                  .substring(0, 1)
                  .toUpperCase() +
                emitterObservation.handoverObservationTypeDescription.substring(
                  1,
                  emitterObservation.handoverObservationTypeDescription.length -
                    1
                ),
              receiverObservation: emitterObservation.receiverObservation,
              emitterUserId: this.userService.getUserProperties().userId,
              emitterDescriptionObservationSolved: '',
              emitterDescriptionObservationNotSolved: '',
              emitterObservationSolved: false,
              emitterObservationNotSolved: false,
              emitterObservationDatetime:
                emitterObservation.emitterObservationDatetime,
              showEmitterObservation:
                !emitterObservation.emitterObservationSolved,
              departmentObservation: emitterObservation.departmentObservation,
            } as HandoverEmitterObservation);
          }
        }
      });
  }

  getLastEngineeringObservations(): void {
    this.handoverService
      .getLastObservations(
        this.handover!.handoverId!,
        ENGINEERING_DEPARTMENT_OBSERVATION,
        this.isDr
      )
      .subscribe((emitterObservations: HandoverObservation[]) => {
        for (let index = 0; index < emitterObservations.length; index++) {
          const emitterObservation = emitterObservations[index];
          if (
            emitterObservation.handoverObservationId &&
            emitterObservation.emitterUserId == null
          ) {
            this.receiverEngineerName = emitterObservation.receiverName;
            this.engineeringOservations.push({
              handoverObservationId: emitterObservation.handoverObservationId,
              handoverObservationTypeId:
                emitterObservation.handoverObservationTypeId,
              handoverObservationTypeDescription:
                emitterObservation.handoverObservationTypeDescription
                  .substring(0, 1)
                  .toUpperCase() +
                emitterObservation.handoverObservationTypeDescription.substring(
                  1,
                  emitterObservation.handoverObservationTypeDescription.length -
                    1
                ),
              receiverObservation: emitterObservation.receiverObservation,
              emitterUserId: this.userService.getUserProperties().userId,
              emitterDescriptionObservationSolved: '',
              emitterDescriptionObservationNotSolved: '',
              emitterObservationSolved: false,
              emitterObservationNotSolved: false,
              emitterObservationDatetime:
                emitterObservation.emitterObservationDatetime,
              showEmitterObservation:
                !emitterObservation.emitterObservationSolved,
              departmentObservation: emitterObservation.departmentObservation,
            } as HandoverEmitterObservation);
          }
        }
      });
  }

  isPendingChanges() {
    const hasPendingChanges =
      this.observations.some(
        (obs) => obs.emitterObservationNotSolved || obs.emitterObservationSolved
      ) ||
      this.engineeringOservations.some(
        (obs) => obs.emitterObservationNotSolved || obs.emitterObservationSolved
      );
    return hasPendingChanges;
  }

  observationNotSolved(index: number): void {
    this.observations[index].emitterObservationNotSolved =
      !this.observations[index].emitterObservationNotSolved;
    this.observations[index].emitterObservationSolved = false;

    this.emitFooterPendingChanges(this.isPendingChanges());
  }

  observationSolved(index: number): void {
    this.observations[index].emitterObservationSolved =
      !this.observations[index].emitterObservationSolved;
    this.observations[index].emitterObservationNotSolved = false;
    this.emitFooterPendingChanges(this.isPendingChanges());
  }

  resizeFooter(): void {
    this.fullscreen = !this.fullscreen;
  }

  getObservations(): void {
    this.handoverService
      .getObservations(this.handover!.handoverId!)
      .subscribe((historyObservations: HandoverHistoryObservation[]) => {
        this.historyObservations = historyObservations;
        this.historyObservations.forEach((o) => {
          o.handoverObservationTypeDescription =
            o.handoverObservationTypeDescription.substring(0, 1).toUpperCase() +
            o.handoverObservationTypeDescription.substring(
              1,
              o.handoverObservationTypeDescription.length - 1
            );
        });
        // Group observations by type and count
        const countsHo = historyObservations.reduce(
          (result: any, handoverObservation: any) => {
            const prop = handoverObservation.handoverObservationTypeId;
            if (!result.hasOwnProperty(prop)) {
              result[prop] = 0;
            }
            result[prop]++;
            return result;
          },
          {}
        );
        this.viewHistory = Object.keys(countsHo).map((k) => {
          return {
            handoverObservationTypeId: Number(k),
            viewHistory: countsHo[k] > 1,
          };
        });
      });
  }

  viewHistoryHoType(
    handoverObservationTypeId: number,
    showEmitterObservation: boolean
  ): boolean {
    return (
      this.viewHistory.filter(
        (vh) =>
          vh.handoverObservationTypeId == handoverObservationTypeId &&
          (vh.viewHistory || !showEmitterObservation)
      ).length > 0
    );
  }

  viewObservationsHistory(handoverObservationTypeId: number): void {
    const emitterName =
      this.userService.getUserProperties().firstname +
      ' ' +
      this.userService.getUserProperties().lastname;

    this.dialogService.openHandoverHistoryObservationsDialog(
      handoverObservationTypeId == HANDOVER_OBSERVATION_WELL_CONDITION
        ? HANDOVER_OBSERVATION_WELL_CONDITION_DIALOG_TITLE
        : HANDOVER_OBSERVATION_DATA_DIALOG_TITLE,
      this.historyObservations.filter(
        (ho) => ho.handoverObservationTypeId == handoverObservationTypeId
      ),
      emitterName,
      '',
      this.handover!.handoverTypeId!
    );
  }

  showTab(tab: string): void {
    this.operationsVisible = tab == 'operations';
  }

  //TODO: Refactorizar. Tambien se usa en handover-card
  getInitialsOfName(fullName: string | undefined): string {
    let initialsName = '';

    if (fullName) {
      if (fullName == 'mí') {
        const name = this.userService.getUserProperties().firstname;
        const lastName = this.userService.getUserProperties().lastname;
        const nameInitial = name ? name.charAt(0).toUpperCase() : '';
        const lastNameInitial = lastName
          ? lastName.charAt(0).toUpperCase()
          : '';
        initialsName = nameInitial + lastNameInitial;
        initialsName = initialsName ? initialsName : fullName.toUpperCase();
      } else {
        const fullNameList: string[] = fullName.split(' ');
        // Take initials for the fist name and the lastname.
        initialsName =
          fullNameList[0].charAt(0).toUpperCase() +
          fullNameList[fullNameList.length - 1].charAt(0).toUpperCase();
      }
    } else {
      initialsName = 'N/N';
    }
    return initialsName;
  }

  engineerObservationNotSolved(index: number): void {
    this.engineeringOservations[index].emitterObservationNotSolved =
      !this.engineeringOservations[index].emitterObservationNotSolved;
    this.engineeringOservations[index].emitterObservationSolved = false;
    this.emitFooterPendingChanges(this.isPendingChanges());
  }

  engineerObservationSolved(index: number): void {
    this.engineeringOservations[index].emitterObservationSolved =
      !this.engineeringOservations[index].emitterObservationSolved;
    this.engineeringOservations[index].emitterObservationNotSolved = false;
    this.emitFooterPendingChanges(this.isPendingChanges());
  }

  getObservationAttachments(): void {
    if (this.handover?.handoverId) {
      this.handoverService
        .getObservationAttachments(this.handover?.handoverId)
        .subscribe((files: ObservationAttachment[]) => {
          if (files) {
            this.observationOperationsAttachment = files.filter(
              (o) =>
                o.departmentObservation == OPERATIONS_DEPARTMENT_OBSERVATION
            );

            this.observationEngineeringAttachment = files.filter(
              (o) =>
                o.departmentObservation == ENGINEERING_DEPARTMENT_OBSERVATION
            );
          }
        });
    }
  }
}
